import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import Modules from '../../components/modules'

import withModules from '../../containers/with-modules'
import withCentreSelector from '../../containers/with-centre-selector'
import Feature from '../../components/feature'
import pagesHoc from '../pages-hoc'
import getUtilityPanelModule from '../../helpers/get-utility-panel-module'
import { PromotionPositionContext } from '../../context'
import styles from './index.scss'

const Home = ({ template, modules, centre, animate }) => {
  const featureModule = modules[0]
  const templateModules = modules.slice(1)
  const utilityPanelModule = getUtilityPanelModule(centre, templateModules)

  const templateModulesWithoutUtilityPanel = [...templateModules]
  templateModulesWithoutUtilityPanel.splice(
    templateModulesWithoutUtilityPanel.indexOf(utilityPanelModule),
    1
  )

  return (
    <Fragment>
      <PromotionPositionContext.Provider
        value={featureModule.analyticsMetadata?.displayId}
      >
        <Feature
          {...featureModule}
          lazyLoad={false}
          utilityPanelModule={utilityPanelModule}
          withMask={animate}
          analyticsMetadata={featureModule.entryAnalyticsMetadata}
        />
      </PromotionPositionContext.Provider>
      <MediaQuery maxWidth={927}>
        <Modules
          useDeckBG
          initialColor="Grey"
          initialAngle="top-left"
          className={styles.initialContentGroup}
          modules={templateModules}
          centreTitle={centre.title}
        />
      </MediaQuery>
      <MediaQuery minWidth={928}>
        <Modules
          useDeckBG
          initialColor="Grey"
          initialAngle="top-left"
          className={styles.initialContentGroup}
          modules={templateModulesWithoutUtilityPanel}
          centreTitle={centre.title}
        />
      </MediaQuery>
    </Fragment>
  )
}

Home.propTypes = {
  modules: PropTypes.array,
  promotionContent: PropTypes.object,
  template: PropTypes.object,
  centre: PropTypes.object,
  animate: PropTypes.bool,
}

Home.defaultProps = {
  modules: [],
}

export default withCentreSelector(withModules(pagesHoc(Home)))
